import { ApiType } from "@gymflow/common";
import { ClubOnboardingSettingsDTO } from "@gymflow/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { onboardingSettings } from "./onboardingSettingsQueryKeys";

export function useMutationOnboardingSettings({ api }: { api: ApiType }) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: ClubOnboardingSettingsDTO) =>
      (await api.onboardingSettingsApi.update(data)).data,
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: onboardingSettings.all(),
      });
    },
  });
}
